const STORAGE_KEY = 'mallAlertBlockRecords';

const ACTION_TYPES = {
  WARNING_ADDED: 'warning-created',
  WARNING_REMOVED: 'warning-removed',
  BLOCKED: 'blocked',
  UNBLOCKED: 'blocked-removed',
};

const ACTION_META = {
  [ACTION_TYPES.WARNING_ADDED]: {
    label: 'Uyarı Listesine Eklendi',
    color: '#FDE68A',
    textColor: '#A16207',
    icon: 'solar:bell-bing-outline',
  },
  [ACTION_TYPES.WARNING_REMOVED]: {
    label: 'Uyarı Kaldırıldı',
    color: '#DCFCE7',
    textColor: '#166534',
    icon: 'solar:bell-off-outline',
  },
  [ACTION_TYPES.BLOCKED]: {
    label: 'Blokaja Alındı',
    color: '#FEE2E2',
    textColor: '#B91C1C',
    icon: 'solar:lock-outline',
  },
  [ACTION_TYPES.UNBLOCKED]: {
    label: 'Blokaj Kaldırıldı',
    color: '#DCFCE7',
    textColor: '#15803D',
    icon: 'solar:lock-unlocked-outline',
  },
};

const getStoredRecords = () => {
  try {
    const parsed = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    return Array.isArray(parsed) ? parsed : [];
  } catch (error) {
    return [];
  }
};

const saveRecords = (records) => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(records));
};

export const formatDateTime = (value) => {
  if (value === null || value === undefined || value === '') return '-';

  // API unix (saniye) formatında gönderiyor (örn. "1783514596")
  const isUnixSeconds = /^\d+$/.test(String(value).trim());
  const date = isUnixSeconds ? new Date(Number(value) * 1000) : new Date(value);
  if (Number.isNaN(date.getTime())) return '-';

  return new Intl.DateTimeFormat('tr-TR', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(date);
};

// flow/list-branch-warnings-blog-logs API kaydını tabloda kullanılan alanlara çevirir
export const normalizeMallAlertBlockLog = (item, index) => ({
  id: item?.id ?? `${item?.createdDateTime}-${index}`,
  createdAt: item?.createdDateTime,
  type: item?.action,
  userName: item?.createdBy || item?.created_by || '-',
  mallTitle: item?.mallTitle || '-',
  storeTitle: item?.branchTitle || '-',
  companyCorporationalCode: item?.companyCorporationalCode || '',
  accountCode: item?.accountCode || '',
  message: item?.content || '-',
});

export const getMallAlertBlockRecords = (mallID) => {
  const records = getStoredRecords();

  return records
    .filter((record) => !mallID || String(record.mallID) === String(mallID))
    .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
};

export const appendMallAlertBlockRecord = (record) => {
  const current = getStoredRecords();
  const next = [
    {
      id: `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
      createdAt: new Date().toISOString(),
      ...record,
    },
    ...current,
  ];

  saveRecords(next);
  return next;
};

export const getActionMeta = (type) =>
  ACTION_META[type] || {
    label: type || '-',
    color: '#E5E7EB',
    textColor: '#374151',
    icon: 'solar:info-circle-outline',
  };

export { ACTION_TYPES };
